export class UserSettings {
  public onboarding: boolean;
}
